<template>
    <div class="layout">
        <Layout>
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <Headers></Headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row :gutter="16" >
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.project_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目总额</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>

                      <Col span="4">
                        <div class="rx-index-box">
                          <div class="box-line">
                            <div class="order-count text-success">
                              {{basic.income_money ?? '0.00'}}
                            </div>
                          </div>
                          <div class="name">项目回款</div>
                          <Icon type="md-contacts" size="26" class="icons" />
                        </div>
                      </Col>
                        <Col span="4">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-danger">
                                        {{basic.debt_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目欠款</div>
                                <Icon type="ios-photos" size="26" class="icons" />
                            </div>
                        </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-orange">
                                        {{basic.expend_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">材料支出</div>
                                <Icon type="md-contacts" size="26" class="icons" />
                            </div>
                        </Col>
                      <Col span="3">
                        <div class="rx-index-box">
                          <div class="box-line">
                            <div class="order-count text-orange">
                              {{basic.expense_money ?? '0.00'}}
                            </div>
                          </div>
                          <div class="name">报销金额</div>
                          <Icon type="ios-rose" size="26" class="icons" />
                        </div>
                      </Col>
                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-success">
                                        {{basic.balance_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">项目结余</div>
                                <Icon type="ios-cafe" size="26" class="icons" />
                            </div>
                        </Col>

                        <Col span="3">
                            <div class="rx-index-box">
                                <div class="box-line">
                                    <div class="order-count text-primary">
                                        {{basic.invoice_money ?? '0.00'}}
                                    </div>
                                </div>
                                <div class="name">开票金额</div>
                                <Icon type="ios-rose" size="26" class="icons" />
                            </div>
                        </Col>

                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 项目金额报表
                                    </div>
                                </template>
                                <template #extra>
                                   <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <line-echart ref="LineEchartBox"></line-echart>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 项目采购报表
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <bar-echart ref="BarEchartBox"></bar-echart>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="24">
                            <Card :bordered="false" class="rx-index-card" dis-hover shadow>
                                <template #title>
                                    <div class="text-primary">
                                        <Icon type="md-stats" size="16"  /> 项目报销报表
                                    </div>
                                </template>
                                <template #extra>
                                    <Icon type="md-calendar" /> {{basic.date}}
                                </template>
                                <div  class="width-100 charts-box">
                                    <bar-echart-expense ref="BarEchartExpenseBox"></bar-echart-expense>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import '@/assets/style.css'
import {getHomeStatic} from "@/apis/public";
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import LineEchart from "@/components/echarts/Line";
import BarEchart from "@/components/echarts/Bar";
import BarEchartExpense from "@/components/echarts/ExpenseBar";

export default {
    name: 'HomeIndex',
    components: {
        Headers, Side, LineEchart, BarEchart, BarEchartExpense
    },
    props:{
        menu_id : { default : "1" }
    },
    data () {
        return {
            menu:[],
            basic: []
        }
    },
    created(){
      this.getHomeStatic();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },

    methods: {
      getHomeStatic(){
        let that = this;
        getHomeStatic().then(e=>{
          that.basic = e.data ?? [];
        })
      },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style lang="less" scoped>
.rx-index-box {
    width: 100%;
    position: relative;
    border: 1px solid #f6f6f6;
    background: #f6f6f6;
    border-radius: 5px;
    padding: 25px 10px;
    position: relative;
    box-shadow: 5px 5px 10px #EEE;
    cursor: pointer;
    transition: all 0.2s ease-in-out 0s;
    &:hover {
        background: #f2f2f2;
        box-shadow: 5px 5px 10px #ccc;
        transition: all 0.2s ease-in-out 0s;
    }
    .name {
        width: 100%;
        font-size: 15px;
        //font-weight: bold;
    }
    .box-line {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 15px;
        .order-count {
            font-size: 20px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .order-count-small {
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            em {
                font-size: 16px;
                padding-left: 10px;
            }
        }
    }
    .icons {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: rgba(40,130,255,0.1);
    }
}
.rx-index-card {
    margin-top: 20px;
}
</style>
